import { render } from "./Mensaje.vue?vue&type=template&id=2aa141fb&scoped=true"
import script from "./Mensaje.vue?vue&type=script&lang=js"
export * from "./Mensaje.vue?vue&type=script&lang=js"

import "./Mensaje.vue?vue&type=style&index=0&id=2aa141fb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2aa141fb"]])

export default __exports__